import {z} from "zod/v4-mini"

export const voronoiTextureFeatureSchema = z.enum(["F1", "F2", "SMOOTH_F1", "DISTANCE_TO_EDGE", "N_SPHERE_RADIUS"])
export type VoronoiTextureFeature = z.infer<typeof voronoiTextureFeatureSchema>

export const voronoiTextureDistanceSchema = z.enum(["EUCLIDEAN", "MANHATTAN", "CHEBYCHEV", "MINKOWSKI"])
export type VoronoiTextureDistance = z.infer<typeof voronoiTextureDistanceSchema>
